import { render } from "./ApplicationLogo.vue?vue&type=template&id=a886e500"
const script = {}

import exportComponent from "/var/www/webcrm-develop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__